import { Capacitor } from '@capacitor/core';

/** Google Tag Manager container for a web build. `params` is the extra query string of a GTM environment (staging's preview/auth values). */
export interface GtmConfig {
  id: string;
  params?: string;
}

/**
 * Loads Google Tag Manager on the web app only (never in the native apps, which have their own
 * analytics). Same as Google's snippet: seeds dataLayer, then adds gtm.js as the first script.
 * Call it as early as possible in main.ts. The <noscript> iframe is left out: the app needs JavaScript.
 */
export function loadGoogleTagManager(config: GtmConfig | null | undefined): void {
  if (!config?.id || Capacitor.isNativePlatform()) return;
  const w = window as unknown as { dataLayer?: Record<string, unknown>[] };
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(config.id)}${config.params ?? ''}`;
  document.head.insertBefore(script, document.head.firstChild);
}
